import { render, staticRenderFns } from "./IconDotsHorizontal.vue?vue&type=template&id=074049d9&functional=true&"
import script from "./IconDotsHorizontal.vue?vue&type=script&lang=js&"
export * from "./IconDotsHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports